import UserAuthService, { buildKeycloakConfig } from "../services/UserAuthService";
import ApiService from "../services/ApiService";
import logger from "../utils/logging";
import { FrontendConfig, Dependencies } from "./config";

/**
 * Wire up all frontend dependencies based on configuration
 * Similar to backend wire.ts pattern
 */
export function wire(config: FrontendConfig): Dependencies {
    logger.info("Initializing frontend dependencies", config);

    // Initialize authentication service
    const authService = new UserAuthService(buildKeycloakConfig(config.authUrl), config.environment);

    // Initialize API service with auth dependency
    const apiService = new ApiService(authService, config.apiUrl);

    logger.debug("Frontend dependencies initialized successfully");

    return {
        config,
        authService,
        apiService,
    };
}
